/* eslint-disable @typescript-eslint/no-explicit-any */
import { reducer, union } from "ts-action";
import { on } from "ts-action-immer";

import * as AC from "../actionCreators";
import { Dictionary } from "../../../globalTypes";
import forTableId, { TableData, makeTableInitialState } from "./forTableId";
import { AdminTableName, TableIdentifier } from "../types";

export type TableDataState = {
  [TI in TableIdentifier as TI["kind"]]: Dictionary<
    TI["idWithinKind"],
    TableData
  >;
};

const initialState: TableDataState = {
  template: {},
  administration: {},
  templateVersion: {}, // V tuhle chvili tu realne verzovaci tabulky neukladame, ale muzeme
};

const TableDataReducer = reducer(
  initialState,

  on(AC.relocalizeAdminTableHeaders, (state, action) => {
    Object.keys(state.administration)
      .map((adminTableName) => adminTableName as AdminTableName)
      .forEach((adminTableName) => {
        const prevState = state.administration[adminTableName];
        state.administration[adminTableName] = forTableId(prevState, action);
      });
  }),

  // Nechat jako posledni v poradi! Tim padem tu muzu vyspreadovat vsechny akce,
  // ale nektere odchytnout mimo (pro kazdou akci se vzdy triggerne jen prvni on)
  on(...union(...Object.values(AC)), (state, action) => {
    if (!action.payload) return;
    const { kind, idWithinKind } = action.payload;

    const defaultChildState = makeTableInitialState({ ...action.payload });

    // Cast bohužel nutnej - https://stackoverflow.com/questions/65327902/derive-typescript-interface-from-discriminiated-union?noredirect=1#comment115509210_65328373
    (state[kind] as any)[idWithinKind] = forTableId(
      (state[kind] as any)[idWithinKind] ?? defaultChildState,
      action
    );
  })
);

export default TableDataReducer;
